<template>
  <div>
    <b-row align="left">
      <b-col md="6" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Daftar Customer</font>
          &nbsp;&nbsp;&nbsp;
          <font class="h5 text-warning border rounded p-1">{{ tanggal }}</font>
        </p>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="4"></b-col>
          <b-col>
            <b-row align="right" class="text-right">
              <b-col></b-col>
              <b-col md="6" align="right" class="text-right">
                <b-input-group class="text-right">
                  <b-input-group-text
                    class="bg-white border-right-0"
                    slot="prepend"
                  >
                    <img src="@/assets/filter.svg" alt />
                  </b-input-group-text>
                  <b-dropdown
                    text="Filter Data"
                    variant="light"
                    toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
                    slot="append"
                  >
                    <b-dropdown-item
                      :style="status == '' ? 'background: #f8f9fc' : ''"
                      @click="statusFilter('')"
                    >
                      <span>All</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      :style="status == 'baru' ? 'background: #f8f9fc' : ''"
                      @click="statusFilter('baru')"
                    >
                      <span class="text-warning">Baru</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      :style="status == 'ditolak' ? 'background: #f8f9fc' : ''"
                      @click="statusFilter('ditolak')"
                    >
                      <span class="text-danger">Ditolak</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      :style="status == 'diproses' ? 'background: #f8f9fc' : ''"
                      @click="statusFilter('diproses')"
                    >
                      <span class="text-info">Diproses</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      :style="status == 'diterima' ? 'background: #f8f9fc' : ''"
                      @click="statusFilter('diterima')"
                    >
                      <span class="text-primary">Diterima</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-input-group>
              </b-col>
              <b-col md="5" align="right" class="text-right">
                <download-csv
                  class="d-none"
                  :data="CSV"
                  name="CustomerList.csv"
                  ref="DownloadCSV"
                ></download-csv>
                <b-button
                  class="btn btn-primary"
                  :disabled="loadingCSV"
                  @click="downloadCSV()"
                >
                  <b-spinner label="Spinning" v-show="loadingCSV"></b-spinner
                  >Export to CSV
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <b-card body-class="py-0 px-0">
      <b-row>
        <b-col md="4" class="border-right text-left pl-5 py-5">
          <b-row>
            <b-col>
              <h5 class>Total Calon Mitra</h5>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <h4 class="mb-0" v-else>
                {{ items ? total_customer : items }}
              </h4>
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col md="11">
                  <b-form-group
                    id="fieldset-1"
                    label="Filter Tanggal"
                    label-for="input-1"
                  >
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 pt-1 form-control img-calender-select border-right-0"
                        md="4"
                      >
                        <img
                          src="@/assets/ic-calendar-copy-30.svg"
                          width="25px"
                          alt
                          class
                        />
                      </b-col>
                      <b-col class="px-0">
                        <datepicker
                          input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 "
                          placeholder="From"
                          v-model="date_from"
                          :format="customFormatter"
                          @input="cxDate()"
                          :disabledDates="element2"
                        ></datepicker>
                      </b-col>
                      <!-- <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="pt-1 px-4 form-control del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left" class="pt-1">
                            <b-col>
                              <b-link @click="resetFromdate" style="text-decoration:none">
                                <i class="text-danger fas fa-times"></i>
                              </b-link>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>-->
                    </b-row>
                    <b-row class="m-0 mt-2">
                      <b-col
                        class="pr-0 pt-1 form-control img-calender-select border-right-0"
                        md="4"
                      >
                        <img
                          src="@/assets/ic-calendar-copy-30.svg"
                          width="25px"
                          alt
                          class
                        />
                      </b-col>
                      <b-col class="px-0">
                        <datepicker
                          input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 "
                          placeholder="To"
                          v-model="date_to"
                          @input="cxDate()"
                          :format="customFormatter"
                          :disabledDates="element"
                        ></datepicker>
                      </b-col>
                      <!-- <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="pt-1 px-4 form-control del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left" class="pt-1">
                            <b-col>
                              <b-link @click="resetTodate" style="text-decoration:none">
                                <i class="text-danger fas fa-times"></i>
                              </b-link>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>-->
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="border-right text-left pl-4 py-5">
          <p class="text-warning font-weight-bold mb-0">Baru</p>
          <b-row>
            <b-col class="font-weight-bold">
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>{{ dashboard ? dashboard.baru.total : dashboard }}</p>
            </b-col>
            <b-col>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{ dashboard ? dashboard.baru.percent.toFixed(2) : dashboard }}%
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="border-right text-left pl-4 py-5">
          <p class="text-danger font-weight-bold mb-0">Ditolak</p>
          <b-row>
            <b-col class="font-weight-bold">
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{ dashboard ? dashboard.ditolak.total : dashboard }}
              </p>
            </b-col>
            <b-col>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{
                  dashboard ? dashboard.ditolak.percent.toFixed(2) : dashboard
                }}
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="border-right text-left pl-4 py-5">
          <p class="text-info font-weight-bold mb-0">Diproses</p>
          <b-row>
            <b-col class="font-weight-bold">
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{ dashboard ? dashboard.diproses.total : dashboard }}
              </p>
            </b-col>
            <b-col>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{
                  dashboard ? dashboard.diproses.percent.toFixed(2) : dashboard
                }}
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="text-left pl-4 py-5">
          <p class="text-primary font-weight-bold mb-0">Diterima</p>
          <b-row>
            <b-col class="font-weight-bold">
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{ dashboard ? dashboard.diterima.total : dashboard }}
              </p>
            </b-col>
            <b-col>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{
                  dashboard ? dashboard.diterima.percent.toFixed(2) : dashboard
                }}%
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <br />
    <div class="text-left">
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!filter"
                  @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right"></b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>
          We're sorry, we're not able to retrieve this information at the
          moment, please try back later
        </p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        ref="cxContent"
        hover
        :items="getInfo"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(created_at)="row">{{
          row.value | DateTime
        }}</template>
        <template v-slot:cell(name)="row">
          <p class="text-primary text-capitalize">{{ row.value }}</p>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-warning" v-if="row.value == 'baru'">Baru</p>
          <p class="text-danger" v-else-if="row.value == 'ditolak'">Ditolak</p>
          <p class="text-info" v-else-if="row.value == 'diproses'">Diproses</p>
          <p class="text-primary" v-else-if="row.value == 'diterima'">
            Diterima
          </p>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            :to="{ name: 'detailCustomer', params: { id: item.id } }"
            class="text-primary"
            v-b-tooltip.hover
            title="View Detail"
          >
            <i class="fas fa-eye"></i>
          </router-link>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{ totalRows }}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      dashboard: [],
      fields: [
        {
          key: "created_at",
          label: "Tanggal Submit",
          sortable: true,
          class: "text-center",
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
          class: "text-center",
        },
        {
          key: "location",
          label: "Lokasi Pilihan",
          sortable: true,
          class: "text-center",
        },
        {
          key: "company_name",
          label: "Nama Perusahaan",
          sortable: true,
          class: "text-center",
        },
        {
          key: "business",
          label: "Bidang Usaha",
          sortable: true,
          class: "text-center",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center",
        },

        { key: "action", label: "Action", class: "text-center" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: "created_at",
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      status: "",
      date_from: new Date(new Date().setDate(new Date().getDate() - 30)),
      date_to: new Date(Date.now()),
      loadingCSV: false,
      CSV: "",
      tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, "/"),
      routename: null,
      customerShow: false,
      total_customer: "",
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  watch: {
    element: {
      handler: function (newValue) {
        if (newValue) {
          this.element = newValue;
        }
      },
      deep: true,
    },
    element2: {
      handler: function (newValue) {
        if (newValue) {
          this.element2 = newValue;
        }
      },
      deep: true,
    },
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    element() {
      var disabledDates = {
        to: new Date(this.date_from - 8640000),
        from: new Date(Date.now() - 8640000),
      };
      return disabledDates;
    },
    element2() {
      var disabledDates = {
        from: new Date(this.date_to + 8640000),
      };
      return disabledDates;
    },
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    // this.$store
    //   .dispatch("cxModule/getCxReports")
    //   .then(response => {
    //     this.loading = false;
    //   })
    //   .catch(error => {
    //     this.$swal({
    //       type: "error",
    //       title: "Oops...",
    //       text: error.response.data.message,
    //       showConfirmButton: false,
    //       timer: 1500
    //     });
    //     this.loading = false;
    //   });
  },
  created() {
    // Set the initial number of items
    // this.totalRows = this.items.length;
    // this.$store.watch(
    //   state => state.cxModule.report,
    //   (newValue, oldValue) => {
    //     this.items = newValue;
    //   }
    // );
  },
  methods: {
    downloadCSV() {
      this.$swal({
        title: "Download CSV Report??",
        text: "Proses ini akan memakan waktu dan beban pada database",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya!",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          this.loadingCSV = true;
          const vm = this;
          var payload = {
            status: this.status,
            date_from: this.date_from
              ? moment(this.date_from).format("YYYY-MM-DD")
              : "",
            date_to: this.date_to
              ? moment(this.date_to).format("YYYY-MM-DD")
              : "",
            page: "page=" + "",
            limit: "limit=" + "",
            sort_by: this.sortDesc
              ? this.sortBy == ""
                ? ""
                : "-" + this.sortBy
              : this.sortBy,
            search_param: "search_param=" + this.filter,
          };
          this.$store
            .dispatch("customerListModule/getCustomerList", payload)
            .then((response) => {
              this.CSV = response.data.data.results;
              setTimeout(() => {
                this.loadingCSV = false;
                this.$refs.DownloadCSV.$el.click();
              }, 1000);
            })
            .catch((error) => {
              this.loadingCSV = false;
              callback([]);
            });
        } else {
        }
      });
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    statusFilter(payload) {
      this.status = payload;
      this.$refs.cxContent.refresh();
    },
    cxDate() {
      if (this.date_to < this.date_from) {
        this.$swal({
          title: "Tanggal tidak sesuai!",
          type: "error",
          showConfirmButton: false,
          timer: 1000,
        });
      } else {
        this.$refs.cxContent.refresh();
      }
    },
    resetFromdate() {
      this.date_from = "";
      this.$refs.cxContent.refresh();
    },
    resetTodate() {
      this.date_to = "";
      this.$refs.cxContent.refresh();
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      var payload = {
        status: this.status,
        date_from: this.date_from
          ? moment(this.date_from).format("YYYY-MM-DD")
          : "",
        date_to: this.date_to ? moment(this.date_to).format("YYYY-MM-DD") : "",
        page: "page=" + ctx.currentPage,
        limit: "limit=" + ctx.perPage,
        sort_by: ctx.sortDesc
          ? ctx.sortBy == ""
            ? ""
            : "-" + ctx.sortBy
          : ctx.sortBy,
        search_param: "search_param=" + ctx.filter,
      };
      this.$store
        .dispatch("customerListModule/getCustomerList", payload)
        .then((response) => {
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
          this.items = response.data.data.results;
          this.dashboard = response.data.data.status;
          this.total_customer = response.data.data.total_record;
        })
        .catch((error) => {
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    date() {
      const currentDateWithFormat = "";
      this.tanggal = currentDateWithFormat;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
</style>
